// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-free/css/all.css";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'lightgallery/src/sass/lightgallery.scss';

import 'bootstrap';
import 'slick-carousel';

import financeCalculator from './utilities/finance-calculator';
import basicNavigation from './header/header-basic';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import inView from 'in-view';

$(function () {

    basicNavigation();

    financeCalculator();

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });

    $('.homepage-carousel .slick').slick({
        dots: true,
        arrows: false,
        vertical: true
    });

    $('.used-truck-detail-images').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.used-truck-detail-images-nav'
    });

    $('.used-truck-detail-images-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.used-truck-detail-images',
        dots: false,
        centerMode: false,
        focusOnSelect: true
    });

    if (!detectIE()) {
        $('.parallax').jarallax({
            speed: 0.8,
            disableParallax: /iPad|iPhone|iPod|Android/,
            disableVideo: /iPad|iPhone|iPod|Android/
        });
    }

    $('.card-new-truck').on('click', function () {
        $(this).toggleClass('flipped');
    });

    $('.card-new-truck .btn').on('click', function (e) {
        e.stopPropagation();
    });


    $('#finance-calculator-enquire').on('click', function (e) {
        e.preventDefault();
        $("#enquiry-tab").tab('show');
    });

    $('.used-trucks')
        .on('click', '.used-trucks-filters-toggle', function (e) {
            e.preventDefault();
            let $expandable = $('.used-trucks-filters-expandable');
            if ($expandable.hasClass('expanded')) {
                $(this).find('.fas').removeClass('fa-minus').addClass('fa-plus');
            } else {
                $(this).find('.fas').removeClass('fa-plus').addClass('fa-minus');
            }
            $expandable.toggleClass('expanded');
        })
        .on('submit', '.used-truck-filter-form', function (e) {
            e.preventDefault();
            const loadingSelector = '.used-trucks-loading';

            $(loadingSelector).removeClass('d-none');
            $('.used-trucks-results').addClass('d-none');

            //Remove name attributes from empty fields so you don't get them in the serialization
            $(this).find('input').each(function (index, obj) {
                if ($(obj).val() === '') {
                    $(obj).removeAttr('name');
                }
            });
            $(this).find('select').each(function (index, obj) {
                if ($(obj).val() === '') {
                    $(obj).removeAttr('name');
                }
            });

            const data = $(this).serialize();
            const url = location.pathname + '?' + data;
            const toRefresh = ['.used-trucks-filters-expandable', '.used-trucks-results'];
            loadAjaxContent(url, toRefresh, loadingSelector);

        })
        .on('click', '.used-trucks-filter-buttons-clear', function (e) {
            $('.used-trucks-loading').removeClass('d-none');
            $('.used-trucks-results').addClass('d-none');

            loadAjaxContent(location.pathname, ['.used-trucks-filters-expandable', '.used-trucks-results'], '.used-trucks-loading');
        });

    initInView();


});


Number.prototype.format = function (n, t) {
    var i = "\\d(?=(\\d{" + (t || 3) + "})+" + (n > 0 ? "\\." : "$") + ")";
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(i, "g"), "$&,");
};

function detectFF() {
    const ua = window.navigator.userAgent;
    if (ua.indexOf('Firefox') !== -1) return true;
    return false;
}

function detectIE() {
    const ua = window.navigator.userAgent;

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    // other browser
    return false;
}

function loadAjaxContent(url, toRefresh, loadingSelector) {
    $.ajax({
        url: url,
        type: 'GET',
        success: function (response) {
            if (loadingSelector) {
                $(loadingSelector).addClass('d-none');
            }
            let html = $(response);
            //Update page elements
            $.each(toRefresh, function (index, cl) {
                let element = html.find(cl);
                $(cl).replaceWith(element);
            });

            history.pushState(null, null, url);
        },
        error: function () {
            if (loadingSelector) {
                $(loadingSelector).addClass('d-none');
            }
        }
    });
}

function initInView() {
    inView('.update-in-view')
        .on('enter', element => {
            $(element).addClass('in-view');
        });
}

window.initInView = initInView;
